import DesignPageContent from "@/app/design/page";

export default function DesignPage() {
  return <DesignPageContent />;
}
